import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_CLIENTS_REQUEST,
    FETCH_CLIENTS_SUCCESS,
    FETCH_CLIENTS_FAILURE,
    FETCH_CLIENT_BY_ID_REQUEST,
    FETCH_CLIENT_BY_ID_SUCCESS,
    FETCH_CLIENT_BY_ID_FAILURE,
    CREATE_CLIENT_REQUEST,
    CREATE_CLIENT_SUCCESS,
    CREATE_CLIENT_FAILURE,
    UPDATE_CLIENT_REQUEST,
    UPDATE_CLIENT_SUCCESS,
    UPDATE_CLIENT_FAILURE,
    DELETE_CLIENT_REQUEST,
    DELETE_CLIENT_SUCCESS,
    DELETE_CLIENT_FAILURE,
} from '../actions/clientActions';
import {
    getClients,
    getClientById,
    createClient,
    updateClient,
    deleteClient,
} from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

function* fetchClientsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getClients, params);
        yield put({ type: FETCH_CLIENTS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des clients');
        yield put({ type: FETCH_CLIENTS_FAILURE, payload: errorMessage });
    }
}

function* fetchClientByIdSaga(action) {
    try {
        const data = yield call(getClientById, action.payload);
        yield put({ type: FETCH_CLIENT_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement du client');
        yield put({ type: FETCH_CLIENT_BY_ID_FAILURE, payload: errorMessage });
    }
}

function* createClientSaga(action) {
    try {
        const data = yield call(createClient, action.payload);
        yield put({ type: CREATE_CLIENT_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la création du client');
        yield put({ type: CREATE_CLIENT_FAILURE, payload: errorMessage });
    }
}

function* updateClientSaga(action) {
    try {
        const { clientId, clientData } = action.payload;
        const response = yield call(updateClient, clientId, clientData);
        // Extraire client_model de la réponse si elle existe
        const updatedClient = response.client_model || response;
        const policiesRequiringManualReview = Array.isArray(response?.policies_requiring_manual_review)
            ? response.policies_requiring_manual_review
            : [];
        yield put({ type: UPDATE_CLIENT_SUCCESS, payload: updatedClient, policiesRequiringManualReview });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la mise à jour du client');
        yield put({ type: UPDATE_CLIENT_FAILURE, payload: errorMessage });
    }
}

function* deleteClientSaga(action) {
    try {
        yield call(deleteClient, action.payload);
        yield put({ type: DELETE_CLIENT_SUCCESS, payload: action.payload });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression du client');
        yield put({ type: DELETE_CLIENT_FAILURE, payload: errorMessage });
    }
}

export function* watchClientRequests() {
    yield takeEvery(FETCH_CLIENTS_REQUEST, fetchClientsSaga);
    yield takeEvery(FETCH_CLIENT_BY_ID_REQUEST, fetchClientByIdSaga);
    yield takeEvery(CREATE_CLIENT_REQUEST, createClientSaga);
    yield takeEvery(UPDATE_CLIENT_REQUEST, updateClientSaga);
    yield takeEvery(DELETE_CLIENT_REQUEST, deleteClientSaga);
}


